import clsx from 'clsx';
export function Markdown(props) {
    var source = props.source, className = props.className;
    return (<div className={clsx('openapi-markdown', className)} dangerouslySetInnerHTML={{ __html: source }}/>);
}
